












































































import {Emit} from 'vue-property-decorator';
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {ResultType} from '@/shared/xhttp';
import {Role, User} from '@/models';

import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';
import storeRole from '@/stores/modules/role';
import storeUser from '@/stores/modules/user';
import CrudUserEditChangePwdDialog from "@/components/Crud/User/EditChangePwdDialog.vue";

@Component({
	components: {
		CrudUserEditChangePwdDialog,
		CrudDeleteDialog,
	}
})
export default class ProfileView extends Vue {

	@Stored(() => storeUser) me!: User;

	@Stored(() => storeRole) private roles!: ResultType<Role>;

	private editPwd: User = null;

	@Emit()
	private onCreate(): void {
	}

	private refresh(): void {
	}
}
